export { NewEventDetailBody } from "./NewEventDetailBody";
